"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = exports.Content = exports.Picture = exports.Box = exports.StyledFeatures = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const react_intl_1 = require("react-intl");
exports.StyledFeatures = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: initial;
	}
`;
exports.Box = styled_components_1.default.div `
	width: 100%;
	padding: 0 2em 3em;
	display: flex;
	position: relative;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('sm')} {
		width: 50%;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		width: 33%;
	}
`;
exports.Picture = styled_components_1.default.div `
	width: 150px;
	height: 150px;
	overflow: hidden;
	align-self: center;
	& img {
		display: block;
		max-width: 100%;
	}
`;
exports.Content = styled_components_1.default.dl `
	align-self: center;
	flex: 1;
	text-align: center;

	dt {
		color: ${props => props.theme.color.brand2};
		font-size: 1.2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
const features = [
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_1_headline" }),
        image: 'piggy-bank-2',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_1_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_2_headline" }),
        image: 'global-data-transfer',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_2_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_3_headline" }),
        image: 'app-window',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_3_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_4_headline" }),
        image: 'office-building',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_4_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_5_headline" }),
        image: 'avatar-network',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_5_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_6_headline" }),
        image: 'hold-envelope-1',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_6_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_7_headline" }),
        image: 'chart-analysis',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_7_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_8_headline" }),
        image: 'cloud-sync-16',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_8_body" }),
    },
    {
        name: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_9_headline" }),
        image: 'people-in-love-1',
        text: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.features.feature_9_body" }),
    },
];
const Features = () => {
    return ((0, jsx_runtime_1.jsx)(exports.StyledFeatures, { children: features.map(item => {
            return ((0, jsx_runtime_1.jsxs)(exports.Box, { children: [(0, jsx_runtime_1.jsx)(exports.Picture, { children: (0, jsx_runtime_1.jsx)("img", { src: `/media/illustrations/streamline-icon-${item.image}.svg`, alt: "" }) }), (0, jsx_runtime_1.jsxs)(exports.Content, { children: [(0, jsx_runtime_1.jsx)("dt", { children: item.name }), (0, jsx_runtime_1.jsx)("dd", { children: item.text })] })] }, item.image));
        }) }));
};
exports.Features = Features;
